import { IBrandViewV2Response } from "@faire/web-api/indigofair/data/IBrandViewV2Response";

export function isReorderArchetype(brandView: IBrandViewV2Response): boolean {
  return brandView.brand_retailer_info?.archetype === "REORDER";
}
